





















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"

/**
 * @status stable
 * @published 4.6.0
 * @changelog 4.6.0 Published.
 */
@Component
export default class JdsWorkbenchBackButton extends Vue {

    @Prop() to!: Location;

    @Ref() linkEl!: HTMLElement;
    hover = false;

    startAnimation() {
        this.linkEl.classList.add('jdsc-workbench-back-link--animate');
        this.hover = true;
    }

    animationTicker() {
        if (!this.hover) {
            this.linkEl.classList.remove('jdsc-workbench-back-link--animate');
        }
    }
}
